<template>
  <validation-observer ref="EditDesignationForm" v-slot="{ invalid, errors }">
    <b-form @submit.prevent="formSubmitted">
      <b-row>
        <b-col sm="12">
          <b-form-group label="Department" label-for="department" :invalid="errors.departmentId">
            <b-form-select v-model="designation.departmentId" :options="departmentOptions" />
            <small class="text-danger">{{ errors.departmentId }}</small>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Working Hours" label-for="workingHours" :invalid="errors.workingHours">
            <validation-provider v-slot="{ errors }" name="Working Hours" rules="required|max_working_hours">
              <b-form-input v-model="designation.workingHours" name="workingHours" placeholder="Working Hours" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Designation Name" label-for="designationName" :invalid="errors.designationName">
            <validation-provider v-slot="{ errors }" name="Designation Name" rules="required">
              <b-form-input v-model="designation.designationName" name="designationName" placeholder="Designation Name" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
  <b-form-group label="Minimum Salary" label-for="minimumSalary">
    <validation-provider #default="{ errors }" name="minimumSalary" :rules="[
      { required: true, message: 'Minimum Salary is required' },
      { 
        numeric_decimal: true, 
        message: 'Please enter a valid number' 
      },
      { 
        validate: value => value >= 0 || 'Salary cannot be negative', 
        message: 'Salary cannot be negative'
      }
    ]">
      <b-form-input v-model.number="designation.minimumSalary" @input="checkNegative" @blur="validate" type="number" name="minimumSalary" placeholder="Minimum Salary" />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</b-col>

<b-col md="12">
  <b-form-group label="Maximum Salary" label-for="maximumSalary">
    <validation-provider
      #default="{ errors }"
      name="maximumSalary"
      :rules="[
      { required: true, message: 'Minimum Salary is required' },
      { 
        numeric_decimal: true, 
        message: 'Please enter a valid number' 
      },
      { 
        validate: value => value >= 0 || 'Salary cannot be negative', 
        message: 'Salary cannot be negative'
      }
    ]"
    >
      <b-form-input v-model.number="designation.maximumSalary" @input="checkNegative" @blur="validate" type="number" name="maximumSalary" placeholder="Maximum Salary" />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</b-col>

        <b-col md="12" class="d-flex justify-content-between">
          <b-button type="submit" variant="primary" :disabled="invalid">
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { BRow, BCol, BForm, BFormInput, BFormGroup, BButton, BSpinner, BFormSelect } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";

// Custom validation rule to limit working hours to numbers only and 24
extend("max_working_hours", {
  validate: (value) => {
    // Check if value is a number and within the range
    const isNumber = /^[0-9]*\.?[0-9]+$/.test(value); // Check if value is a number
    if (!isNumber) return false; // Return false if not a number

    const hours = parseFloat(value);
    return hours >= 0 && hours <= 24; // Return true if within the range
  },
  message: "Working hours must be a number between 0 and 24.",
});

export default {
  name: "EditDesignation",
  components: {
    BRow, BCol, BForm, BFormInput, BFormGroup, BButton, BSpinner, ValidationProvider, ValidationObserver, BFormSelect
  },
  props: {
    designation: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
  return {
    loading: false,
   
  };
},
  computed: {
    isSalaryInvalid() {
      return this.maximumSalary < this.minimumSalary;
    },
    ...mapGetters("departmentModule", ["departments"]),
    departmentOptions() {
      return this.departments.map((department) => ({
        text: department.departmentName,
        value: department.departmentId,
      }));
    },
  },
  async mounted() {
    this.$swal({
      title: "Loading...",
      text: "Please wait while the details are loading...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        this.$swal.showLoading();
      },
    });

    await this.getDepartmentListAction().then(() => {
      this.$swal.close();
    }).catch ((error) => {
      console.error("Error fetching departments:", error);
    });
  },
  
  methods: {
    ...mapActions("designationModule", ["updateDesignationAction"]),
    ...mapActions("departmentModule", ["getDepartmentListAction"]),
    
    checkNegative() {
    if (this.designation.minimumSalary < 0) {
      this.designation.minimumSalary = 0; // Set to 0 or show a warning if needed
    }

    if (this.designation.maximumSalary < 0) {
      this.designation.maximumSalary = 0; // Set to 0 or show a warning if needed
    }
  },
    // formSubmitted() {
    //   this.$refs.EditDesignationForm.validate().then((success) => {
    //     if (success) {
    //       this.loading = true;
    //       let loader = this.$swal({
    //         title: "Processing...",
    //         text: "Please wait while the Designation is being updated",
    //         onOpen: () => {
    //           this.$swal.showLoading();
    //         },
    //         allowOutsideClick: () => !this.$swal.isLoading(),
    //         buttonsStyling: false,
    //         showConfirmButton: false,
    //       });

    //       const designationData = {
    //         departmentId: this.designation.departmentId,
    //         workingHours: this.designation.workingHours,
    //         designationName: this.designation.designationName,
    //         minimumSalary: this.designation.minimumSalary,
    //         maximumSalary: this.designation.maximumSalary,
    //         designationId: this.designation.id,
    //       };

    //       this.updateDesignationAction(designationData)
    //         .then(() => {
    //           loader.close();
    //           this.success();
    //           this.$bvModal.hide("modal-id");
    //           this.getDesignationListAction();
    //         })
    //         .catch((error) => {
    //           loader.close();
    //           this.error(error.response.data);
    //           this.getDesignationListAction();
    //         })
    //         .finally(() => {
    //           this.loading = false;
    //         });
    //     }
    //   });
    // },

    errorSalary() {
      this.$swal({
        title: "Error!",
        text: " Maximum salary must be greater than minimum salary!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    formSubmitted() {
  if (!this.designation || !this.designation.minimumSalary || !this.designation.maximumSalary) {
    console.error("Designation data is missing.");
    return; // Prevent form submission if required data is missing
  }

  this.$refs.EditDesignationForm.validate().then((success) => {

    if(this.designation.maximumSalary < this.designation.minimumSalary){
            this.errorSalary();
            // this.loading = false;
            // loader.close();
            return;
          }

    if (success) {
      this.loading = true;
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the Designation is being updated",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      

      const designationData = {
        departmentId: this.designation.departmentId,
        workingHours: this.designation.workingHours,
        designationName: this.designation.designationName,
        minimumSalary: this.designation.minimumSalary,
        maximumSalary: this.designation.maximumSalary,
        designationId: this.designation.id,
      };
console.log("payload", designationData);
      this.updateDesignationAction(designationData)
        .then(() => {
          loader.close();
          this.success();
          this.$bvModal.hide("modal-id");
          this.getDesignationListAction();
        })
        .catch((error) => {
          loader.close();
          this.error(error.response.data);
          this.getDesignationListAction();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  });
},

    success() {
      this.$swal({
        title: "Designation updated!",
        text: "You have successfully updated the Designation!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$emit("DesignationUpdated");
        }
      });
    },

    error(data) {
      this.$swal("Error!", this.getErrorString(data) || "Failed!", "error");
    },

    getErrorString(data) {
      let msg = "<div><p>Cannot post your request due to the following errors:</p>";
      if (data.errors) {
        for (let prop in data.errors) {
          msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop].toString().replace("$.", "")}</p>`;
        }
      } else if (data.message) {
        msg += `<p>${data.message}</p>`;
      }
      return msg + "</div>";
    },
  },
};
</script>
